import { diff } from 'deep-diff';
export var changesMedatada = {
  methods: {
    getChanges: function getChanges() {
      var actualMedataFields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var changeMetadataFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var actualColumnFields = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var changeColumnFields = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var changes = [];
      var filter = function filter(diff) {
        return diff.kind === 'E';
      };
      var diff_table = diff(actualMedataFields, changeMetadataFields);
      if (diff_table !== undefined) {
        var diff_metadata = diff_table.filter(filter);
        var changes_metadata = diff_metadata.map(function (diff) {
          var change = {
            change_type: 'metadata',
            column: '',
            field: diff.path[0],
            old: diff.lhs,
            new: diff.rhs
          };
          return change;
        });
        Array.prototype.push.apply(changes, changes_metadata);
      }
      var _d = diff(actualColumnFields, changeColumnFields);
      var diff_columns = _d ? _d.filter(filter) : [];
      var changes_columns = diff_columns.map(function (diff) {
        var index_change = diff.path[0];
        var column_obj = changeColumnFields.at(index_change);
        var change = {
          change_type: 'column',
          column: column_obj.column,
          field: diff.path[2],
          old: diff.lhs,
          new: diff.rhs
        };
        return change;
      });
      Array.prototype.push.apply(changes, changes_columns);
      return changes;
    }
  },
  computed: {
    classDiff: function classDiff() {
      var _this = this;
      return function (field) {
        var found = _this.changes.find(function (change) {
          return change.field === field;
        });
        return {
          'resaltador': found !== undefined
        };
      };
    },
    classColumnDiff: function classColumnDiff() {
      var _this2 = this;
      return function (columnName, fieldName) {
        var found = _this2.changes.find(function (change) {
          return change.column === columnName && change.field === fieldName;
        });
        return {
          'resaltador': found !== undefined
        };
      };
    }
  }
};